<template>
  <v-layout row wrap>
    <v-flex xs4>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        @update:return-value="saveChanges"
      >
        <template v-slot:activator="{ on }">
          <v-btn :disabled="disabled" color="brown darken-2" dark v-on="on">
            <v-icon medium>search</v-icon>&nbsp; Organization Search Tool
          </v-btn>
        </template>

        <v-card class="bg-light-blue">
          <v-toolbar dark class="brown darken-2">
            <v-btn class="icon primary ml-3" @click="dialog = false">
              Close
            </v-btn>
            <v-toolbar-title class="ml-6">Organization Search Tool</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <div>
            <p style="margin: 0; padding: 0;"><br/><b>
              You can only add a specific institution to the list one time. To add several institutions, it will probably save you time to stay on this page and add them all at once.
              <br />(1) Enter the organization name or code in the Search box.
              <br />(2) When the name appears in the table below, click on the plus sign.
              <br />(3) After you see the box saying the institution was added, start over at (1).
            </b></p>

            <p><br/><b>
              When you return to the question page, you will probably have to click on “SAVE” then click “Home” and then return to the page before you see your institutions.
            </b></p>
          </div>

          <v-layout row wrap class="py-2">
            <v-flex xs1 />
            <v-flex xs10>
              <v-text-field
                id="search-field"
                v-model="value"
                label="Type an organization name or code"
                prepend-inner-icon="search"
                persistent-hint
                hint="Min 3 characters to start search"
                clearable
              />
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="headers"
            :items="organizationList"
            :loading="loading"
            loading-text="Loading... Please wait"
            class="elevation-1 mx-5"
          >
            <template v-slot:item.action="{ item }">
              <v-icon class="mr-2 green--text" @click="addClick(item)">
                mdi-plus-circle
              </v-icon>
            </template>
          </v-data-table>

          <p class="my-4 body-2">
            <v-icon medium>help</v-icon>&nbsp;If you cannot find an institution or organization code, contact survey support.
          </p>

          <v-snackbar v-model="snackbar" top :color="snackColor">
            {{ snackMessage }}
            <v-btn dark text @click="closeSnack()">Close</v-btn>
          </v-snackbar>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { lookUpService } from "../../services/lookUpService";

export default {
  name: "OrganizationSearchTool",
  props: {
    snackMessage: String,
    snackbarHolder: Boolean,
    snackColor: String,
    disabled: Boolean
  },

  data: () => ({
    dialogHolder: false,
    value: null,
    loading: false,
    headers: [
      { text: "Add", value: "action", sortable: false },
      { text: "Code", value: "organizationFice" },
      { text: "Name", value: "organizationName" },
      { text: "State", value: "state" },
      { text: "City", value: "city" },
      { text: "Type", value: "organizationTypeCode" }
    ],
    organizationList: []
  }),

  methods: {
    addClick (item) {
      this.$emit("addClick", {
        code: item.organizationFice,
        name: item.organizationName,
        type: item.organizationTypeCode
      });
    },

    closeSnack () {
      this.$emit("closeSnack");
    },

    saveChanges () {
      this.$store.commit("setIsLoading", { isLoading: true });
      this.$emit("save");
    }
  },

  watch: {
    value (newVal) {
      if (newVal && newVal.length > 2) {
        this.loading = true;

        const me = this; lookUpService
				.searchOrganizations({ search: newVal })
				.then(function (response) {
					me.organizationList =
					response && response.data && response.data.results ? response.data.results
					: [];
					me.loading = false;
				})
				.catch(function (e) {
					console.error(e);
					me.loading = false;
				});
      } else {
        this.organizationList = [];
      }
    }
  },
  computed: {
    dialog: {
      get () {
        return this.dialogHolder;
      },
      set (newVal) {
        const navTop = document.getElementById("survey-nav");
        if (navTop) {
          navTop.classList.toggle("fullscreen", newVal);
        }
        this.dialogHolder = newVal;
				this.$emit("dialog-changed", newVal);
      }
    },

    snackbar: {
      get () {
        return this.snackbarHolder;
      },
      set () {
        this.closeSnack();
      }
    }
  }
};
</script>

<style scoped>
.bg-light-blue {
  background-color: #d9e2f3 !important;
}
</style>
